export default () => import(/* webpackChunkName: 'coffee/app/agreement/sdk-list' */ './SdkList');
